<ng-template #template>
  <div class="svc-surface-placeholder">
    <div class="svc-surface-placeholder__image" [class]="'svc-surface-placeholder__image--' + name"></div>
    <div class="svc-surface-placeholder__text">
      <div class="svc-surface-placeholder__title">{{placeholderTitleText}}</div>
      <div class="svc-surface-placeholder__description">{{placeholderDescriptionText}}</div>
    </div>
  </div>
</ng-template>